import React, { useState, useEffect } from 'react';
import { AnimatePresence } from "framer-motion";
import ProductCard from "../ProductCard";
import LoaderAnimation from "../../lib/loaderAnimation";

export default function TrainingHighlighted ({products}){
    const [filterData, setFilterData] = useState(products);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if(products?.length>0){
            setFilterData(products);
            setLoading(false);
        }
    }, [products]);

    return(
        <>
            <div className="default-tabs tabs-box">
                <div className="tabs-content wow fadeInUp animated">
                    <div className="tab active-tab">
                        <div className="row">
                            <div className="content-side col-lg-12 col-md-12 col-sm-12">
                                <div className="blog-grid">
                                    <div className="row col-12">
                                        {loading ?
                                            <LoaderAnimation version={'2'} />
                                            :
                                            filterData?.map((product) => (
                                                <AnimatePresence key={product.id}>
                                                    <ProductCard
                                                        product={product}
                                                        colLg={6}
                                                        imgHeight={412}
                                                        highlighted={true}/>
                                                </AnimatePresence>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

